import { useTheme, FONT_SIZE } from '@shopify/polaris-viz-core';
import { jsx } from 'react/jsx-runtime';
import { useLabels } from '../../../Labels/hooks/useLabels.js';
import { TextLine } from '../../../TextLine/TextLine.js';

const TEXT_DROP_SHADOW_SIZE = 3;
function ErrorText({
  errorText,
  width,
  height
}) {
  const {
    chartContainer: {
      backgroundColor
    }
  } = useTheme();
  const {
    lines
  } = useLabels({
    allowLineWrap: true,
    labels: [errorText],
    targetWidth: width
  });
  return /*#__PURE__*/jsx("g", {
    style: {
      transform: `translateY(${Math.max(0, height / 2 - FONT_SIZE / 2)}px)`,
      filter: `
        drop-shadow( ${TEXT_DROP_SHADOW_SIZE}px 0px 1px ${backgroundColor})
        drop-shadow( -${TEXT_DROP_SHADOW_SIZE}px  0px 1px ${backgroundColor})
        drop-shadow( 0px ${TEXT_DROP_SHADOW_SIZE}px 1px ${backgroundColor})
        drop-shadow( 0px -${TEXT_DROP_SHADOW_SIZE}px 1px ${backgroundColor})
      `
    },
    children: /*#__PURE__*/jsx(TextLine, {
      index: 0,
      line: lines[0]
    })
  });
}

export { ErrorText };
